var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.31,18.27c-16.46,0-28.41,7.65-28.41,18.18v1.14c0,1.88,1.53,3.41,3.41,3.41h50c1.88,0,3.41-1.53,3.41-3.41 v-1.14C70.72,25.92,58.77,18.27,42.31,18.27z M68.45,37.59c0,0.63-0.51,1.14-1.14,1.14h-50c-0.63,0-1.14-0.51-1.14-1.14v-1.14 c0-9.07,11.24-15.91,26.14-15.91s26.14,6.84,26.14,15.91V37.59z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.27,
    cy: 31.91,
    r: 1.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.08,
    cy: 34.18,
    r: 1.14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.04,
    cy: 31.91,
    r: 1.14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.27,
    cy: 34.18,
    r: 1.14
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.22,
    cy: 30.77,
    r: 1.14
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.99,
    cy: 27.36,
    r: 1.14
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.22,
    cy: 27.36,
    r: 1.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.42,50.09h-3.2c-0.27,0-0.52,0.09-0.73,0.26l-6.09,5.08l-6.09-5.08c-0.2-0.17-0.46-0.26-0.73-0.26h-3.2 H22.99c-0.63,0-1.14,0.51-1.14,1.14c0,0.63,0.51,1.14,1.14,1.14h18.39h2.79l4.09,3.41l2.41,2.01c0.21,0.18,0.47,0.26,0.73,0.26 c0.26,0,0.52-0.09,0.73-0.26l2.41-2.01l4.09-3.41h2.79h0.21c0.63,0,1.14-0.51,1.14-1.14c0-0.63-0.51-1.14-1.14-1.14H61.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.04,45.54c1.36,0,1.99,0.42,2.78,0.95c0.89,0.59,1.99,1.33,4.04,1.33s3.15-0.74,4.04-1.33 c0.79-0.53,1.42-0.95,2.78-0.95c1.36,0,1.99,0.42,2.78,0.95c0.89,0.59,1.99,1.33,4.04,1.33s3.15-0.74,4.04-1.33 c0.79-0.53,1.42-0.95,2.78-0.95s1.99,0.42,2.78,0.95c0.89,0.59,1.99,1.33,4.04,1.33s3.15-0.74,4.04-1.33 c0.79-0.53,1.42-0.95,2.78-0.95c1.36,0,1.99,0.42,2.78,0.95c0.89,0.59,1.99,1.33,4.04,1.33s3.15-0.74,4.04-1.33 c0.79-0.53,1.42-0.95,2.78-0.95c0.63,0,1.14-0.51,1.14-1.14c0-0.63-0.51-1.14-1.14-1.14c-2.05,0-3.15,0.74-4.04,1.33 c-0.79,0.53-1.42,0.95-2.78,0.95c-1.36,0-1.99-0.42-2.78-0.95c-0.89-0.59-1.99-1.33-4.04-1.33c-2.05,0-3.15,0.74-4.04,1.33 c-0.79,0.53-1.42,0.95-2.78,0.95s-1.99-0.42-2.78-0.95c-0.89-0.59-1.99-1.33-4.04-1.33s-3.15,0.74-4.04,1.33 c-0.79,0.53-1.42,0.95-2.78,0.95s-1.99-0.42-2.78-0.95c-0.89-0.59-1.99-1.33-4.04-1.33s-3.15,0.74-4.04,1.33 c-0.79,0.53-1.42,0.95-2.78,0.95c-1.36,0-1.99-0.42-2.78-0.95c-0.89-0.59-1.99-1.33-4.04-1.33c-0.63,0-1.14,0.51-1.14,1.14 C13.9,45.03,14.41,45.54,15.04,45.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,50.09h-0.57c-0.63,0-1.14,0.51-1.14,1.14c0,0.63,0.51,1.14,1.14,1.14h0.57c0.94,0,1.7,0.76,1.7,1.7 c0,0.94-0.76,1.7-1.7,1.7h-8.65l-2.73,2.27h10.81v1.14c0,2.51-2.04,4.55-4.55,4.55H22.99c-2.51,0-4.55-2.04-4.55-4.55v-1.14h28.99 l-2.73-2.27H17.88c-0.94,0-1.7-0.76-1.7-1.7c0-0.94,0.76-1.7,1.7-1.7h0.57c0.63,0,1.14-0.51,1.14-1.14c0-0.63-0.51-1.14-1.14-1.14 h-0.57c-2.19,0-3.98,1.78-3.98,3.98c0,1.58,0.93,2.94,2.27,3.58v1.54c0,3.76,3.06,6.82,6.82,6.82h38.64c3.76,0,6.82-3.06,6.82-6.82 v-1.54c1.34-0.64,2.27-2,2.27-3.58C70.72,51.87,68.94,50.09,66.74,50.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.33517f7e1b42cc31ffdb28e0a171f670.svg";
export { ForwardRef as ReactComponent };